import React from 'react';
import { Play, Heart } from 'lucide-react';

const ChannelCard = ({ channel, onClick, onFavorite, isFavorite }) => {
  const defaultLogo = `https://ui-avatars.com/api/?name=${encodeURIComponent(channel.name)}&background=E50914&color=fff&size=200`;

  return (
    <div
      className="channel-card group cursor-pointer"
      onClick={() => onClick(channel)}
      data-testid={`channel-card-${channel.id}`}
    >
      {/* Poster Image */}
      <div className="relative aspect-video rounded-lg overflow-hidden bg-[#1A1A1A]">
        <img
          src={channel.logo || defaultLogo}
          alt={channel.name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = defaultLogo;
          }}
        />
        
        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-14 h-14 bg-[#E50914] rounded-full flex items-center justify-center transform scale-75 group-hover:scale-100 transition-transform duration-300">
            <Play className="w-6 h-6 text-white ml-1" fill="currentColor" />
          </div>
        </div>

        {/* Category Badge */}
        <div className="absolute top-2 left-2">
          <span className="px-2 py-1 bg-black/70 text-[10px] uppercase tracking-wider text-[#A3A3A3] rounded">
            {channel.category}
          </span>
        </div>

        {/* Favorite Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onFavorite(channel);
          }}
          className={`absolute top-2 right-2 p-2 rounded-full transition-all duration-200 ${
            isFavorite 
              ? 'bg-[#E50914] text-white' 
              : 'bg-black/70 text-[#A3A3A3] hover:text-white'
          }`}
          data-testid={`favorite-btn-${channel.id}`}
        >
          <Heart className="w-4 h-4" fill={isFavorite ? 'currentColor' : 'none'} strokeWidth={1.5} />
        </button>
      </div>

      {/* Channel Info */}
      <div className="mt-3">
        <h3 className="text-white font-semibold text-sm truncate group-hover:text-[#E50914] transition-colors">
          {channel.name}
        </h3>
      </div>
    </div>
  );
};

export default ChannelCard;
